/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_Failed_SingleInputs */

const en_batch_subtitle_export_failed_single = /** @type {(inputs: Batch_Subtitle_Export_Failed_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to export subtitle`)
};

const fr_batch_subtitle_export_failed_single = /** @type {(inputs: Batch_Subtitle_Export_Failed_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l’exportation du sous-titre`)
};

const de_batch_subtitle_export_failed_single = /** @type {(inputs: Batch_Subtitle_Export_Failed_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitelexport fehlgeschlagen`)
};

const it_batch_subtitle_export_failed_single = /** @type {(inputs: Batch_Subtitle_Export_Failed_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile esportare i sottotitoli`)
};

const ru_batch_subtitle_export_failed_single = /** @type {(inputs: Batch_Subtitle_Export_Failed_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось экспортировать субтитры.`)
};

const es_batch_subtitle_export_failed_single = /** @type {(inputs: Batch_Subtitle_Export_Failed_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo exportar el subtítulo`)
};

const zh_cn2_batch_subtitle_export_failed_single = /** @type {(inputs: Batch_Subtitle_Export_Failed_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕导出失败`)
};

const ja_batch_subtitle_export_failed_single = /** @type {(inputs: Batch_Subtitle_Export_Failed_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕のエクスポートに失敗しました`)
};

const hi_batch_subtitle_export_failed_single = /** @type {(inputs: Batch_Subtitle_Export_Failed_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक निर्यात करने में विफल`)
};

const pt_pt2_batch_subtitle_export_failed_single = /** @type {(inputs: Batch_Subtitle_Export_Failed_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao exportar legenda`)
};

/**
* | output |
* | --- |
* | "Failed to export subtitle" |
*
* @param {Batch_Subtitle_Export_Failed_SingleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_failed_single = /** @type {((inputs?: Batch_Subtitle_Export_Failed_SingleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_Failed_SingleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_batch_subtitle_export_failed_single(inputs)
	if (locale === "de") return de_batch_subtitle_export_failed_single(inputs)
	if (locale === "it") return it_batch_subtitle_export_failed_single(inputs)
	if (locale === "ru") return ru_batch_subtitle_export_failed_single(inputs)
	if (locale === "es") return es_batch_subtitle_export_failed_single(inputs)
	if (locale === "zh-CN") return zh_cn2_batch_subtitle_export_failed_single(inputs)
	if (locale === "ja") return ja_batch_subtitle_export_failed_single(inputs)
	if (locale === "hi") return hi_batch_subtitle_export_failed_single(inputs)
	if (locale === "pt-PT") return pt_pt2_batch_subtitle_export_failed_single(inputs)
	return en_batch_subtitle_export_failed_single(inputs)
});